__turbopack_context__.v({
  "board": "TodayBoard-module__WYG4Qq__board",
  "capacity": "TodayBoard-module__WYG4Qq__capacity",
  "coldStart": "TodayBoard-module__WYG4Qq__coldStart",
  "continued": "TodayBoard-module__WYG4Qq__continued",
  "explainerLink": "TodayBoard-module__WYG4Qq__explainerLink",
  "section": "TodayBoard-module__WYG4Qq__section",
  "skeleton": "TodayBoard-module__WYG4Qq__skeleton",
  "skeletonRow": "TodayBoard-module__WYG4Qq__skeletonRow",
});
